const sectionTextSurveyCss = `
[data-type='section-text-survey'] [data-attribute='card-container'] {
  padding: 40px 0;
}

[data-type='section-text-survey'] .wrap-card {
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
}

[data-type='section-text-survey'] .wrap-card .card-left {
  width: calc((100% - 50px) / 2);
  display: flex;
  align-items: center;
}

[data-type='section-text-survey'] .wrap-card .card-left .wrap-text h1,
[data-type='section-text-survey'] .wrap-card .card-left .wrap-text h2,
[data-type='section-text-survey'] .wrap-card .card-left .wrap-text h3 {
  font-size: 24px;
}

[data-type='section-text-survey'] .wrap-card .card-right {
  width: calc((100% - 50px) / 2);
}

[data-type='section-text-survey'] .wrap-card .card-right .card-content .card-survay .wrap-survay-item {
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: solid 1px #e5e7eb;
  padding: 10px 0;
}

[data-type='section-text-survey']
  .wrap-card
  .card-right
  .card-content
  .card-survay
  .wrap-survay-item:first-child {
  border-top: solid 1px #e5e7eb;
}

[data-type='section-text-survey'] .wrap-card .card-right .card-content .card-survay .wrap-survay-item .left-item {
  width: 80px;
  position: relative;
}

[data-type='section-text-survey']
  .wrap-card
  .card-right
  .card-content
  .card-survay
  .wrap-survay-item
  .left-item
  svg {
  width: 100%;
  display: block;
}

[data-type='section-text-survey']
  .wrap-card
  .card-right
  .card-content
  .card-survay
  .wrap-survay-item
  .left-item
  .wrap-percent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  line-height: 20px;
  white-space: nowrap;
}

[data-type='section-text-survey'] .wrap-card .card-right .card-content .card-survay .wrap-survay-item .right-item {
  flex: 1;
  font-size: 16px;
}

@container (max-width: 768px) {
  [data-type='section-text-survey'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-text-survey'] .wrap-card {
    gap: 20px;
  }

  [data-type='section-text-survey'] .wrap-card .card-left {
    width: 100%;
    order: 1 !important;
    justify-content: center;
  }

  [data-type='section-text-survey'] .wrap-card .card-left .wrap-text {
    text-align: center;
  }

  [data-type='section-text-survey'] .wrap-card .card-left .wrap-text h1,
  [data-type='section-text-survey'] .wrap-card .card-left .wrap-text h2,
  [data-type='section-text-survey'] .wrap-card .card-left .wrap-text h3 {
    font-size: 16px;
  }

  [data-type='section-text-survey'] .wrap-card .card-right {
    width: 100%;
    order: 2 !important;
  }
}
`;

export default sectionTextSurveyCss;
